/**
 * Tiny chime synthesiser using Web Audio API. No asset to ship, no CDN
 * lookup, works offline. Plays a quick two-note teal-coloured "ding"
 * (~180 ms) suitable for new-notification alerts.
 *
 * Browsers autoblock audio until the user has interacted with the page.
 * That's a feature, not a bug — pre-interaction sound would be hostile
 * UX. We swallow the AudioContext error silently in that case.
 */
let _ctx = null;
function ctx() {
  if (_ctx) return _ctx;
  try {
    const C = window.AudioContext || window.webkitAudioContext;
    if (!C) return null;
    _ctx = new C();
    return _ctx;
  } catch { return null; }
}

export function playNotificationChime() {
  const ac = ctx();
  if (!ac) return;
  // Resume if the user has already interacted; otherwise this no-ops
  if (ac.state === "suspended") {
    ac.resume().catch(() => {});
  }
  const now = ac.currentTime;
  const tones = [
    { freq: 880, start: 0,    dur: 0.09 },  // A5
    { freq: 1320, start: 0.07, dur: 0.13 }, // E6 — pleasing fifth above
  ];
  tones.forEach(({ freq, start, dur }) => {
    try {
      const osc = ac.createOscillator();
      const gain = ac.createGain();
      osc.type = "sine";
      osc.frequency.setValueAtTime(freq, now + start);
      gain.gain.setValueAtTime(0, now + start);
      gain.gain.linearRampToValueAtTime(0.18, now + start + 0.012);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + start + dur);
      osc.connect(gain).connect(ac.destination);
      osc.start(now + start);
      osc.stop(now + start + dur + 0.02);
    } catch { /* swallow */ }
  });
}
